var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgF3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_Phone Number") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "001-Fone-Dynamics-Homepage---@2560",
    transform: "translate(-1254.000000, -2105.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "#3-Body-1",
    transform: "translate(7.000000, 1407.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card",
    transform: "translate(1156.000000, 178.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-78",
    transform: "translate(71.000000, 500.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-75",
    transform: "translate(20.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_Phone-Number"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    fill: "#A4EED7",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    rx: 25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(15.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,0 L6.15384615,0 L6.15384615,3.84615385 L0,3.84615385 L0,2 L-2.22044605e-16,2 C-3.57315355e-16,0.8954305 0.8954305,-1.91384796e-17 2,-2.22044605e-16 Z",
    id: "Rectangle-17",
    fill: "#59CFAA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-17-Copy",
    fill: "#30D769",
    x: 6.92307692,
    y: 0,
    width: 6.15384615,
    height: 3.84615385
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8461538,0 L18,0 L18,-2.22044605e-16 C19.1045695,-4.2495073e-16 20,0.8954305 20,2 L20,3.84615385 L13.8461538,3.84615385 L13.8461538,0 Z",
    id: "Rectangle-17-Copy-2",
    fill: "#59CFAA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-17",
    fill: "#59CFAA",
    x: 0,
    y: 5.38461538,
    width: 6.15384615,
    height: 3.84615385
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-17-Copy",
    fill: "#30D769",
    x: 6.92307692,
    y: 5.38461538,
    width: 6.15384615,
    height: 3.84615385
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-17-Copy-2",
    fill: "#59CFAA",
    x: 13.8461538,
    y: 5.38461538,
    width: 6.15384615,
    height: 3.84615385
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,10.7692308 L6.15384615,10.7692308 L6.15384615,14.6153846 L2,14.6153846 L2,14.6153846 C0.8954305,14.6153846 -7.52907669e-16,13.7199541 -8.8817842e-16,12.6153846 L0,10.7692308 Z",
    id: "Rectangle-17",
    fill: "#59CFAA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-17-Copy",
    fill: "#30D769",
    x: 6.92307692,
    y: 10.7692308,
    width: 6.15384615,
    height: 3.84615385
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.92307692,16.1538462 L13.0769231,16.1538462 L13.0769231,18 L13.0769231,18 C13.0769231,19.1045695 12.1814926,20 11.0769231,20 L8.92307692,20 L8.92307692,20 C7.81850742,20 6.92307692,19.1045695 6.92307692,18 L6.92307692,16.1538462 Z",
    id: "Rectangle-17-Copy",
    fill: "#30D769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8461538,10.7692308 L20,10.7692308 L20,12.6153846 L20,12.6153846 C20,13.7199541 19.1045695,14.6153846 18,14.6153846 L13.8461538,14.6153846 L13.8461538,10.7692308 Z",
    id: "Rectangle-17-Copy-2",
    fill: "#59CFAA"
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgF3);
export default __webpack_public_path__ + "static/media/f3.98eb68064c4dbff5442fe26bb542ced6.svg";
export { ForwardRef as ReactComponent };